module.exports = __webpack_public_path__ + "static/headshot-baa7a915cd121eb366b06a4139230dd5.jpg";